import React, { Suspense } from 'react';

import { Preloader } from 'components/ui';

import styles from './SuspenseWrapper.module.scss';

export const SuspenseWrapper: React.FC = ({ children }) => (
  <Suspense
    fallback={
      <div className={styles.root}>
        <Preloader />
      </div>
    }
  >
    {children}
  </Suspense>
);
